import React from 'react'
import Landing from '../routes/landings/Garage'

const Garage = () => {
  return <Landing />
}

export default Garage
